import React from 'react'

export default function CBNBenefits() {
  return (
   <ul className='benefitList mb-0'>
    <li>
        Enable Community networks for Producers (Farmers).
    </li>
    <li>
        Enable Agri ecosystem partners to sell input to the farmer and buy raw material from the farmer.
    </li>
    <li>
        Enable Government official to distribute the assets within the community.
    </li>
   </ul>
  )
}
